// VNM : seule « 4 VNM en autonomie » passe par tuteur → entreprise → stagiaire ; autres supports inchangés
export const VNM_TRIPARTITE = 'Encadrement avec 4 VNM en autonomie';

export const exigeTripartite = (categorie, sousCategorie) => categorie !== 'VNM' || sousCategorie === VNM_TRIPARTITE;
